<template>
  <div v-if="data">
    <Summary
      :data="{
        ...data.summary,
        updatedAt: data.timeline[data.timeline.length - 1]?.eventAt,
        paymentMethod: data.paymentDetails?.type ?? '',
        email: data.customerDetails.customerEmail,
        firstName: data.customerDetails.customerFirstName,
        lastName: data.customerDetails.customerLastName,
        enableOffSchedulePayment: data.enableOffSchedulePayment,
      }"
      class="pb-12"
      @refresh="loadOrderData"
    />
    <Timeline
      :data="data.timeline"
      :status="data.summary.status"
      class="pb-6"
    />
    <hr class="pb-6">
    <Details
      v-bind="{ ...data.summary, checkoutName: data.details.checkoutName }"
      class="pb-6"
    />
    <PaymentMethod
      v-if="data.paymentDetails"
      :paymentDetails="data.paymentDetails"
      class="pb-6"
    />
    <Payments
      :installments="data.payments.map((installment) => {
        const updated = {
          ...installment,
          currency: data?.summary.currency ?? '',
          productName: data?.details.checkoutName ?? '',
        };
        return updated
      })"
    />
  </div>
  <div v-else>
    <div class="flex items-center justify-center w-full h-full">
      <TbLoading />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, onActivated } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { TbLoading } from '@/components/tasty_bistro';
import { Pages } from '@/router';
import { getLoan, GetLoanResponse } from './api/get_loan';
import Summary from './components/summary.vue';
import Timeline from './components/timeline.vue';
import Details from './components/details.vue';
import PaymentMethod from './components/payment_method.vue';
import Payments from './components/payments.vue';

const route = useRoute();
const router = useRouter();
const projectId = route.params.projectId as string;
const orderId = route.params.id as string;
const data = ref<GetLoanResponse>();

const loadOrderData = async () => {
  data.value = await getLoan({ projectId, orderId });
  if (data.value.summary.origin !== 'Funding') {
    router.push({ name: Pages.notFound });
  }
};

onActivated(async () => {
  await loadOrderData();
});

onBeforeMount(async () => {
  await loadOrderData();
});

</script>
